import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastService } from '../../../services/toast.service';
import { DescricaoPadraoService } from '../../../services/descricao-padrao.service';
import { SeveridadeToast } from '../../../models/enums/severidade-toast.enum';
import { JwtHelper } from '../../../helpers/jwtDecode.helper';
import { SpinnerService } from '../../../services/spinner.service';
import { Icones } from '../../../shared/variaveisDeRotas';

@Component({
  selector: 'app-descricao-padrao-adicionar',
  templateUrl: './descricao-padrao-adicionar.component.html',
  styleUrls: ['./descricao-padrao-adicionar.component.scss']
})
export class DescricaoPadraoAdicionarComponent implements OnInit {
  @Output() tituloChange = new EventEmitter<string>();
  @Output() iconeChange = new EventEmitter<string>();

  descricaoPadraoForm: FormGroup = new FormGroup({
    id: new FormControl(0),
    descricao: new FormControl('', Validators.required),
    detalhes: new FormControl('',Validators.required),
    usuarioId: new FormControl(''),
  });
  caminhoImagem: string = '../../../assets/img/undraw_annotation_re_h774.svg';
  private userId: string;

  constructor(
    private router: Router,
    private toastService: ToastService,
    private descricaoPadraoService: DescricaoPadraoService,
    private jwtHelper: JwtHelper,
    private spinnerService: SpinnerService,
  ) { }

  ngOnInit(): void {
    this.tituloChange.emit('Adicionar Descrição Padrão');
    this.iconeChange.emit(Icones.pranchetaAmarelo);

    this.userId = this.jwtHelper.getUserIdFromToken();
    this.descricaoPadraoForm.get('usuarioId')?.setValue(this.userId);
  }

  onSubmit(): void {
    if (this.descricaoPadraoForm.valid) {
      this.spinnerService.show('Adicionando descrição padrão...');
      this.descricaoPadraoService.addDescricaoPadrao(this.descricaoPadraoForm.value)
        .subscribe({
          next: () => {
            this.retornarMensagemSucesso('Descrição criada com sucesso.');
            this.router.navigate(['/descricao-padrao']);
            this.spinnerService.hide();
          },
          error: (e) => {
            this.retornarMensagemErro(e);
            this.spinnerService.hide();
          }
        });
    }
  }

  onCancel(): void {
    this.router.navigate(['/descricao-padrao']);
  }

  retornarMensagemSucesso(mensagem: string) {
    this.toastService.setMensagemToast(mensagem, SeveridadeToast.Success);
  }

  retornarMensagemErro(e: any) {
    let errorMessage = 'Erro desconhecido';

    if (typeof e.error === 'string') {
      errorMessage = e.error;
    } else if (Array.isArray(e.error)) {
      errorMessage = e.error.join(', ');
    } else if (e.error?.message) {
      errorMessage = e.error.message;
    } else {
      console.error('Erro ao processar erro:', e);
    }

    this.toastService.setMensagemToast(
      `Erro ao criar Descrição Padrão: ${errorMessage}`,
      SeveridadeToast.Error
    );
  }
}
